import {
  Link,
  Table as BaseTable,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { createUuidFromText } from "@metriport/shared/common/uuid";
import stringify from "json-stringify-safe";

export const Table = ({
  id,
  data,
  columns,
  linkColumns = [],
  css = {},
}: {
  id: string;
  data: { [key: string]: string | number | object | undefined }[];
  columns: string[];
  linkColumns?: string[];
  css?: object;
}) => {
  return (
    <TableContainer>
      <BaseTable size={"sm"} key={id} overflowX={"visible"} {...css}>
        <Thead>
          <Tr>
            {columns.map((c, i) => (
              <Th key={`${id}-header-${i}`}>{c}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {data.map(row => {
            const values = columns.map(c => row[c]);
            const rowKey =
              typeof row.key === "string"
                ? row.key
                : row.id
                ? String(row.id)
                : createUuidFromText(stringify(row));
            return (
              <Tr key={rowKey}>
                {values.map((v, i) => {
                  const cellKey = `${rowKey}-cell-${i}`;
                  if (linkColumns.includes(columns[i]) && typeof v === "string") {
                    return (
                      <Td key={cellKey}>
                        <Link color="blue" href={v.toString()} isExternal>
                          {columns[i]}
                        </Link>
                      </Td>
                    );
                  } else {
                    return (
                      <Td key={cellKey}>
                        {typeof v === "object" ? (v as React.ReactNode) : v ?? "undefined"}
                      </Td>
                    );
                  }
                })}
              </Tr>
            );
          })}
        </Tbody>
      </BaseTable>
    </TableContainer>
  );
};
